import {inject, Injectable} from '@angular/core';
import {onCLS, onINP, onLCP} from 'web-vitals';
import {InsightsService} from '../insights/insights.service';

@Injectable({
  providedIn: 'root',
})
export class WebVitalsService {
  private applicationInsights = inject(InsightsService);
  constructor() {}

  initWebVitals() {
    onCLS((metric) => this.reportMetric(metric));
    onINP((metric) => this.reportMetric(metric));
    onLCP((metric) => this.reportMetric(metric));
  }

  private reportMetric(metric: any) {
    // Send metric to Application Insights
    this.applicationInsights.logMetric(metric.name, metric.value, {
      id: metric.id,
      rating: metric.rating,
      navigationType: metric.navigationType,
    });
  }
}
